import { AdminAdoptionService } from './api/AdminAdoptionService'
import { AdoptionModelData } from './models/AdoptionModel'

const AdoptionModule = {
  namespaced: true,
  state: AdoptionModelData(),
  getters: {
    fetchAdoptionList: state => state.adoptionList,
    fetchQueryParams: state => state.queryParams,
    fetchMappedAdoptionList: state => state.mappedAdoptionList,
    fetchAdoptionLevel: state => state.adoptionLevel,
    fetchAdoptionLevelFor: state => state.adoptionLevelFor,
    fetchAdoptionName: state => state.adoptionName,
    fetchExportAdoptionList: state => state.exportAdoptionList
  },
  mutations: {
    setAdoptionList (state, data) {
      state.adoptionList = data.list
    },
    addQueryParams (state, queryParams) {
      state.queryParams = queryParams
    },
    setMappedAdoptionList (state, data) {
      state.mappedAdoptionList = data.list
    },
    setAdoptionData (state, data) {
      state.adoptionLevel = data.adoptionLevel
      state.adoptionLevelFor = data.adoptionLevelFor
      state.adoptionName = data.adoptionName
    },
    setExportAdoptionList (state, data) {
      state.exportAdoptionList = data.list
    },
    deleteAdoptionItem (state, payload) {
      state.adoptionList.splice(payload.id, 1)
    }
  },
  actions: {
    /**
     * Get adoption list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getAdoptionList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchAdoptionList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get Export adoption list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getExportAdoptionList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchAdoptionList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setExportAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setExportAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getExportPoposedAdoptionList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchProposedAdoptionList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setExportAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setExportAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getExportAdoptionActivityReportList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchAdoptionActivityReportList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setExportAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setExportAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get filter csv file list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async fetchCSVFile ({ state, commit }, { resolve, reject, totalAdoptions }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchCSVFile(queryParams, totalAdoptions)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Get Mapped adoption list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getMappedAdoptionList ({ state, commit }, { resolve, reject, adoptionLevel, adoptionLevelFor }) {
      /* let adoptionLevel = state.adoptionLevel
      let adoptionLevelFor = state.adoptionLevelFor */
      /* If param values are present on state then will use it, else consider values from function params */
      if (state.adoptionLevel !== '') {
        adoptionLevel = state.adoptionLevel
      }
      if (state.adoptionLevelFor !== '') {
        adoptionLevelFor = state.adoptionLevelFor
      }
      try {
        const response = await AdminAdoptionService.fetchMappedAdoptionList(adoptionLevel, adoptionLevelFor)
        const { success, data } = response.data
        if (success === true) {
          commit('setMappedAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setMappedAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * edit adoption record
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async editAdoptionItem ({ dispatch }, { resolve, reject, editedData }) {
      try {
        const response = await AdminAdoptionService.editAdoptionItem(editedData)
        const { success, data } = response.data
        if (success) {
          dispatch('getAdoptionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * add adoption record
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async addAdoptionItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.addAdoptionItem(formData)
        const { success, data } = response.data
        if (success) {
          dispatch('getAdoptionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
     * Change Adoption Status
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async changeAdoptionStatusItems ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.changeAdoptionStatusItems(formData)
        const { success, data } = response.data
        if (success) {
          // dispatch('getMappedAdoptionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          // dispatch('getMappedAdoptionList', { resolve, reject })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async addBulkAdoptions ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.addBulkAdoptions(formData)
        const { success, data } = response.data
        if (success) {
          // dispatch('getMappedAdoptionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          // dispatch('getMappedAdoptionList', { resolve, reject })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async importAdoptionFile ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.importAdoptionFile(formData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async importICCAdoptionFile ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.importICCAdoptionFile(formData)
        const { success, data } = response.data
        if (success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getProposedAdoptionList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchProposedAdoptionList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async getAdoptionActivityReportList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await AdminAdoptionService.fetchAdoptionActivityReportList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setAdoptionList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setAdoptionList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        commit('setAdoptionList', {
          list: []
        })
        reject && reject(error)
      }
    },
    async validateAdoptionItem ({ dispatch }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.validateAdoptionItem(formData)
        const { success, data } = response.data
        if (success === true) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async deleteAdoptionItem ({ dispatch, commit }, { resolve, reject, formData }) {
      try {
        const response = await AdminAdoptionService.deleteAdoptionItem(formData)
        const { success, data } = response.data
        if (success === true) {
          commit('deleteAdoptionItem', { formData })
          dispatch('getAdoptionList', { resolve, reject })
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    async fetchAdoptionDetails ({ commit }, { resolve, reject, id }) {
      try {
        const response = await AdminAdoptionService.fetchAdoptionDetails(id)
        const { data } = response
        if (data.success) {
          resolve && resolve(data)
        } else {
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default AdoptionModule
